module.exports = __webpack_public_path__ + "723494a45f26bb1427c6d43205333ff1.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags.png
// module id = ./src/images/flags.png
// module chunks = main